<style lang="scss" scoped>
.invalid-feedback {
  display: block;
}

i.fas {
  display: inline-block;
  padding: 0.5em 0.8em;
  border: 1px solid #d4d6db;
  border-radius: 100%;
  margin-right: 0.5rem;
  cursor: pointer;

  &.fa-male {
    &.selected {
      color: $male;
      border-color: $male;
    }

    &:hover {
      box-shadow: 0px 0px 10px $male;
    }
  }

  &.fa-female {
    &.selected {
      border-color: $female;
      color: $female;
    }

    &:hover {
      box-shadow: 0px 0px 10px $female;
    }
  }
}

.disabled {
  opacity: 0.66;
  i.fas {
    cursor: auto;

    &.fa-male {
      &:hover {
        box-shadow: none;
      }
    }

    &.fa-female {
      &:hover {
        box-shadow: none;
      }
    }
  }
}
</style>
<template>
  <div :class="{ 'is-invalid': hasErrors, disabled: disabled }">
    <i
      class="fas fa-male text-xl"
      :class="{ selected: isGender(0) }"
      @click="setGender(0)"
    ></i>
    <i
      class="fas fa-female text-xl"
      :class="{ selected: isGender(1) }"
      @click="setGender(1)"
    ></i>
    <div
      v-if="hasErrors"
      v-for="error in attribute.errors"
      :key="error"
      class="invalid-feedback"
    >
      {{ error }}
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      genders: []
    };
  },
  created() {
    var value = this.value;
    if (typeof value === "string" && this.multiple) {
      value = [];
      var options = this.options;
      JSON.parse(this.value).forEach(function(element, index) {
        value[index] = options[element];
      });
    }
    this.genders = this.options.map((option, index) => {
      const obj = {};
      obj.selected = this.multiple
        ? Array.isArray(value) && value.includes(option)
        : option === value;
      obj.label = option;
      obj.value = index;
      return obj;
    });
    this.$emit("input", this.selection());
  },
  props: {
    value: {
      required: true
    },
    attribute: {
      required: true,
      type: Object
    },
    disabled: {
      default: false,
      type: Boolean
    }
  },
  computed: {
    options() {
      return this.attribute.options;
    },
    multiple() {
      return Boolean(this.attribute.multiSelect);
    },
    hasErrors() {
      return this.attribute.errors.length !== 0;
    }
  },
  methods: {
    setGender(value) {
      if (this.disabled) {
        return;
      }

      if (!this.multiple) {
        this.genders[value === 0 ? 1 : 0].selected = false;
        this.genders[value].selected = true;
      } else {
        this.genders[value].selected = !this.genders[value].selected;
      }

      this.$emit("input", this.selection());
    },
    selection() {
      const selection = this.genders.reduce(
        (accumulator, select) => {
          if (select.selected) {
            this.multiple
              ? accumulator.push(select.value)
              : (accumulator = select.value);
          }
          return accumulator;
        },
        this.multiple ? [] : 0
      );
      return this.multiple ? JSON.stringify(selection) : selection;
    },
    isGender(value) {
      return this.genders[value].selected;
    }
  }
};
</script>
